<div class="main_div">
  <div class="payment-method">Donation History</div>

  <div class="form_div">
    <div class="input_div">
      <label class="field_label requiredMark">Select Date</label>
      <dx-date-range-box
        class="time_line w-100"
        labelMode="floating"
        displayFormat="dd MMM, yyyy"
        [startDate]="startDate"
        [endDate]="endDate"
        (onValueChanged)="dateChanged($event)"
      >
        <dx-validator validationGroup="validationGrp">
          <dxi-validation-rule
            type="required"
            message="Start and End Date is Required"
          ></dxi-validation-rule>
        </dx-validator>
      </dx-date-range-box>
    </div>
    <div class="input_div">
      <label class="field_label requiredMark">Select Company</label>
      <dx-select-box
        class="input_field"
        placeholder="Select Company"
        [dataSource]="companyList"
        [displayExpr]="'name'"
        [valueExpr]="'id'"
        [value]="selectedCompany"
        (onValueChanged)="onValueChanged($event)"
        [showClearButton]="true"
        [searchEnabled]="true"
        [searchExpr]="'name'"
        [readOnly]="!startDate || !endDate"
      >
      </dx-select-box>
    </div>
    <!-- <div class="input_div d-flex flex-row gap-3">
      <div class="">
        <label class="field_label">Donation Type</label>
        <dx-select-box
          [dataSource]="[
            { status: 'All' },
            { status: 'Campaign' },
            { status: 'Direct NGO' }
          ]"
          displayExpr="status"
          valueExpr="status"
          [(value)]="selectedDonationType"
          placeholder="Select Status"
          (onValueChanged)="onDonationTypeChanged($event)"
          class="input_field"
        ></dx-select-box>
      </div>
      <div class="">
        <label class="field_label">Select Type</label>
        <dx-select-box
          [dataSource]="[
            { status: 'ALL' },
            { status: 'DONATED' },
            { status: 'PLEDGED' }
          ]"
          displayExpr="status"
          valueExpr="status"
          [(value)]="selectedStatus"
          placeholder="Select Status"
          (onValueChanged)="onStatusChanged($event)"
          class="input_field"
        ></dx-select-box>
      </div>
      <div
        class=""
        style="align-items: center; justify-content: center; margin-top: 24px"
      >
        <dx-check-box
          [elementAttr]="{ 'aria-label': 'Checked' }"
          class="checkbox"
          text="Whatsapp Call Request"
          (onValueChanged)="filterList()"
          [(ngModel)]="whatsappFilter"
        >
        </dx-check-box>
      </div>
    </div> -->
  </div>
  <div class="datagrid_container" style="margin-top: 16px; margin-bottom: 16px">
    @if(ngoSelected) {

    <dx-data-grid
      class="donor_list_data_grid"
      [dataSource]="recentActivity"
      [showBorders]="false"
      [showColumnLines]="false"
      [showRowLines]="false"
      [allowColumnResizing]="true"
      columnResizingMode="widget"
      [focusedRowEnabled]="false"
      [rowAlternationEnabled]="false"
      rowTemplate="rowDonationList"
      [wordWrapEnabled]="true"
      [columnAutoWidth]="true"
    >
      <dxo-paging [pageSize]="10" [pageIndex]="0"> </dxo-paging>
      <dxo-pager
        *ngIf="recentActivity?.length > 10"
        [visible]="true"
        [showPageSizeSelector]="true"
        [showInfo]="false"
        [showNavigationButtons]="true"
        [allowedPageSizes]="[10, 25, 50]"
      >
        <!-- [allowedPageSizes]="[10]" -->
      </dxo-pager>
      <dxo-search-panel [visible]="true" [width]="600" placeholder="Search...">
      </dxo-search-panel>
      <dxo-header-filter
        [visible]="true"
        [allowSearch]="true"
      ></dxo-header-filter>
      <dxo-scrolling
        [scrollByContent]="true"
        columnRenderingMode="virtual"
        showScrollbar="always"
      ></dxo-scrolling>
      <dxo-sorting mode="multiple"></dxo-sorting>
      <dxi-column
        caption="Donor Name"
        dataField="name"
        alignment="left"
        [width]="'16%'"
      ></dxi-column>
      <dxi-column
        caption="Email & Phone"
        dataField="email"
        alignment="center"
        [width]="'12%'"
        [allowSorting]="false"
        [allowFiltering]="false"
      ></dxi-column>
      <dxi-column
        caption="Transaction Id"
        dataField="transactionId"
        alignment="center"
        [width]="'12%'"
        [allowSorting]="false"
        [allowFiltering]="false"
      >
      </dxi-column>
      <dxi-column
        caption="Date & Time"
        dataField="created_at"
        alignment="center"
        [width]="'12%'"
        [allowFiltering]="false"
      >
      </dxi-column>
      <dxi-column
        caption="Amount"
        dataField="amount"
        alignment="center"
        style="border: none"
        [width]="'12%'"
      >
      </dxi-column>
      <dxi-column
        caption="Matching %"
        dataField="amount"
        alignment="center"
        style="border: none"
        [width]="'12%'"
        [allowFiltering]="false"
      >
      </dxi-column>
      <dxi-column
        caption="Campaign"
        dataField="campaign_title"
        alignment="center"
        [width]="'12%'"
      >
      </dxi-column>
      <dxi-column
        caption="Status"
        dataField="status"
        alignment="center"
        style="border: none"
        [width]="'12%'"
      >
      </dxi-column>
      <dxi-column caption="Change Status" alignment="center" [width]="'12%'">
      </dxi-column>
      <tbody class="bg-white" *dxTemplate="let row of 'rowDonationList'">
        <tr style="display: contents !important">
          <td>
            <div class="donor-profile row_white">
              <div class="profile-avatar">
                <img
                  class="profile_img"
                  loading="lazy"
                  [src]="
                    row?.data?.profile_img ||
                    './assets/images/round_profile.png'
                  "
                  alt=""
                />
              </div>
              <div class="profile-details">
                <!-- (click)="routeToDonorInfo(row?.data?.donor_id)" -->
                <div class="donor-name fs_18 c_0054a6 cursor">
                  {{ row?.data?.name }}
                </div>
                <!-- <div class="donor-email fs_18 text-start">
                       {{ row?.data?.phoneNumber }}
                     </div> -->
              </div>
            </div>
          </td>
          <td>
            <div class="donor-name" style="overflow-wrap: anywhere">
              <div>{{ row?.data?.email || "N/A" }}</div>
              <div style="color: rgb(143, 137, 130); font-size: 12px">
                {{ row?.data?.phone || row?.data?.whatsapp_no || "N/A" }}
              </div>
            </div>
          </td>
          <td>
            <div class="profile-details">
              <div class="donor-email">
                {{ row?.data?.payment_method || "N/A" }}
              </div>
              <div
                (click)="openDetailsPopup(row?.data)"
                class="donor-name c_0054a6 cursor text-decoration-underline"
              >
                {{ row?.data?.transaction_id ? "Received" : "N/A" }}
              </div>
            </div>
          </td>
          <td>
            <div class="profile-details">
              <div class="donor-name">
                {{ row?.data?.created_at | date : "dd MMM yyyy" }}
              </div>
              <div class="donor-email">
                {{ row?.data?.created_at | date : "hh:mm a" }}
              </div>
            </div>
          </td>
          <td>
            <div class="donor-name">
              ৳ {{ (row?.data?.amount | number) || 0 }}
            </div>
          </td>
          <td>
            <div class="donor-name">
              {{ row?.data?.matching_percentage | number }}%
            </div>
          </td>
          <td>
            <div class="donor-name c_0054a6">
              {{
                row?.data?.is_direct_donation
                  ? row?.data?.ngo_name
                  : row?.data?.campaign_title
              }}
            </div>
          </td>
          <td>
            <div
              class="donor-name"
              [ngStyle]="{
                color:
                  row?.data?.status === 'PAYMENT_PROCESSING'
                    ? '#ffd700'
                    : row?.data?.status === 'FAILED'
                    ? '#D92D20'
                    : row?.data?.status === 'REFUNDED'
                    ? '#ff0062'
                    : '#0054a6'
              }"
            >
              ●
              {{
                row?.data?.status === "PAYMENT_PROCESSING"
                  ? "Payment Processing"
                  : (row?.data?.status | titlecase)
              }}
            </div>
          </td>
          <td>
            <dx-select-box
              [dataSource]="
                row?.data?.status === 'PLEDGED'
                  ? statusOptionsPledged
                  : statusOptions
              "
              placeholder="Change Status"
              [showClearButton]="true"
              [width]="'70%'"
              [style]="'margin-inline:auto'"
              (onValueChanged)="statusChanged($event, row?.data)"
            ></dx-select-box>
          </td>
        </tr>
      </tbody>
    </dx-data-grid>
    }
    <!-- @else {
    <div class="no_data">Please select a Company</div>
    } -->
  </div>
</div>
<app-receipts [receipt]="receipt" [receipt_file]="receiptFile"></app-receipts>

<dx-popup
  [maxWidth]="846"
  [height]="'auto'"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [(visible)]="customPledgePopup"
  [showTitle]="true"
  (onHiding)="resetStatus(event)"
>
  <!-- (onHiding)="pledgePopHiding()" -->
  <div
    class="d-flex flex-column"
    style="height: auto; max-height: 80vh; overflow-x: auto"
  >
    <div class="payment-method">Confirm Pledging</div>

    <dx-scroll-view width="100%" height="100%">
      <div class="pic_name">
        <img
          src="../../../../../assets/images/round_profile.png"
          alt="profile_pic"
        />
        <div class="font_18_bold value">{{ donation?.name }}</div>
        <div class="font_18 value">{{ donation?.email }}</div>
      </div>

      <div class="fields">
        <div style="display: flex; justify-content: space-between">
          <div class="value">Pledged Amount</div>
          <div class="value money">
            ৳{{ (donation?.pledged_amount | number) || 0 }}
          </div>
        </div>
        <!-- <div>
        <div class="value">Messages</div>
        <div class="popup_value">
          {{ pledgeDetails.comment }}
        </div>
      </div> -->
        <div>
          <div class="value">Whatsapp</div>
          <div class="popup_value">
            {{ donation?.whatsapp_no || "Not Available" }}
          </div>
        </div>
        <div>
          <label class="value requiredMark">Received Amount</label>
          <dx-number-box
            class="input_field"
            [showClearButton]="true"
            format="৳ #,##0"
            [invalidValueMessage]="'Value must be a number'"
            [(ngModel)]="pledgePaymentModel.received_amount"
            (keydown)="preventMinusSign($event)"
          >
            <dx-validator validationGroup="pledgeValidationGrp">
              <dxi-validation-rule
                type="required"
                message="Target amount is required"
              ></dxi-validation-rule>
              <dxi-validation-rule
                type="range"
                [min]="1"
                message="Amount must be a positive value."
              ></dxi-validation-rule>
            </dx-validator>
          </dx-number-box>
        </div>
        <div>
          <label class="value requiredMark">Payment Method</label>
          <dx-select-box
            class="input_field"
            [showClearButton]="true"
            [placeholder]="'Enter payment method'"
            [(ngModel)]="pledgePaymentModel.payment_method"
            [dataSource]="['CASH', 'ROCKET', 'NAGAD', 'BKASH', 'BANK_TRANSFER']"
          >
            <dx-validator validationGroup="pledgeValidationGrp">
              <dxi-validation-rule type="required" message="Area is required.">
              </dxi-validation-rule>
            </dx-validator>
          </dx-select-box>
        </div>
        <div>
          <label class="value requiredMark">Transaction ID</label>
          <dx-text-box
            class="input_field"
            [showClearButton]="true"
            [(ngModel)]="pledgePaymentModel.transaction_id"
          >
            <dx-validator validationGroup="pledgeValidationGrp">
              <dxi-validation-rule
                type="required"
                message="Transaction Id is required"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>
      </div>

      <div class="buttons">
        <button class="yellow-button-md" (click)="cancelCustomPledgePopup()">
          Cancel
        </button>
        <button class="blue-button-md" (click)="customizePledgeAmount()">
          Confirm
        </button>
      </div>
    </dx-scroll-view>
  </div>
</dx-popup>
